import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConstants } from '../../common';
import { Observable } from 'rxjs';
import { IPlaylistAddResponse, IPlaylistContents, IPlaylistResponse } from '../../models/playlist.model';
import { IResponseMessage } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class PlaylistService {

  constructor(private http: HttpClient) { }

  getAllPlaylist(): Observable<IPlaylistResponse> {
    return this.http.get<IPlaylistResponse>(ApiConstants.playlist);
  }

  getPlaylistById(playlist_id: number): Observable<IPlaylistContents> {
    return this.http.get<IPlaylistContents>(ApiConstants.playlist + playlist_id + '/');
  }

  addPlaylist(Playlist: FormData): Observable<IPlaylistAddResponse> {
    return this.http.post<IPlaylistAddResponse>(ApiConstants.playlist, Playlist);
  }

  updatePlaylist(playlist_id: number, playlist: FormData): Observable<IPlaylistAddResponse> {
    return this.http.put<IPlaylistAddResponse>(ApiConstants.playlist + playlist_id + '/', playlist);
  }

  deletePlaylistById(playlist_id: number): Observable<IResponseMessage> {
    return this.http.delete<IResponseMessage>(ApiConstants.playlist + playlist_id + '/');
  }

}
